module.exports = __webpack_public_path__ + "media/3_22.29385c02.wav";